module.exports = __webpack_public_path__ + "assets/img/success.1f66d651.png";